import React, { useContext, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { SyncOutlined } from "@mui/icons-material";

export default function DatePickerField(props) {
  const { className, label, required, name, value, placeholder, errors, onChangeHandler = () => { } } = props
  const [singleDate, setSingleDate] = useState(null);
  const [mintime, setminTime] = useState(undefined);
  const [hours, setHours] = useState(undefined);

  const calculateMinTime = date => {
    let isToday = moment(date).isSame(moment(), 'day');
    if (isToday) {
      let nowAddOneHour = moment(new Date()).toDate();
      return nowAddOneHour;
    }
    return setHours(new Date(), 7)
  }

  useEffect(() => {
    setminTime(calculateMinTime(new Date()))
  }, [])


  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };


  const singleDatepickerChange = (event) => {
    setSingleDate(prevValue => {
      let customeEvent = {
        target: {
          name: '',
          value: '',
        }
      }
      customeEvent.target.value = event;
      customeEvent.target.name = name
      onChangeHandler(customeEvent)
      return event;
    })
  }

  const datepickerRef = useRef(null);
  function handleClickDatepickerIcon() {
    const datepickerElement = datepickerRef.current;
    datepickerElement.setFocus(true);
  }

  return (
    <>
      <div className={`px-1 py-1 mt-4 ${className}`} >
        <label>
          <span className='text-blurgray text-16F'>{label} {required && <span className="text-scogoorange">*</span>} </span>
        </label>
        <div className=" w-full relative">
          <DatePicker wrapperClassName="w-full" className={`border-b text-black pl-2 rounded-6px bg-white w-full p-2`}
            isClearable={false}
            dateFormat="yyyy/MM/dd HH:mm"
            name={name}
            selected={value ? value : singleDate}
            minDate={mintime}
            maxTime={new Date(0, 0, 0, 20)}
            minTime={new Date(0, 0, 0, 8)}
            filterTime={filterPassedTime}
            placeholderText={placeholder || "Please select a date"}
            showTimeSelect
            timeFormat="p"
            autoComplete='off'
            timeInputLabel="Time:"
            timeIntervals={60}
            ref={datepickerRef}
            onChange={(event) => singleDatepickerChange(event)} />
          <div className="absolute" style={{ top: "20%", right: "28%", bottom: "78%", left: "90%" }}>
            <span className="material-icons text-3xl " onClick={() => handleClickDatepickerIcon()} > calendar_month </span>
          </div>
          {errors?.[name] && <span className="text-scogoRed text-base font-normal">{errors[name]}</span>}
        </div>
      </div>
    </>
  )
}
